"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const isCreatingCampaign = (state = false, action) => {
    switch (action.type) {
        case 'CREATE_CAMPAIGNS_REQUEST':
            return true;
        case 'CREATE_CAMPAIGNS_SUCCESS':
        case 'CREATE_CAMPAIGNS_FAILURE':
        default:
            return state;
    }
};
const isFetching = (state = false, action) => {
    switch (action.type) {
        case 'FETCH_CAMPAIGNS_REQUEST':
            return true;
        case 'FETCH_CAMPAIGNS_SUCCESS':
        case 'FETCH_CAMPAIGNS_FAILURE':
        default:
            return state;
    }
};
const isNewCampaignPopoverOpen = (state = false, action) => {
    switch (action.type) {
        case 'OPEN_NEW_CAMPAIGN_POPOVER':
            return true;
        case 'CLOSE_NEW_CAMPAIGN_POPOVER':
            return false;
        default:
            return state;
    }
};
const isNewCampaignPopoverClosing = (state = false, action) => {
    switch (action.type) {
        case 'START_CLOSING_NEW_CAMPAIGN_POPOVER':
            return true;
        case 'OPEN_NEW_CAMPAIGN_POPOVER':
        case 'CLOSE_NEW_CAMPAIGN_POPOVER':
            return false;
        default:
            return state;
    }
};
const isCampaignTypeSelectorOpen = (state = false, action) => {
    switch (action.type) {
        case 'OPEN_CAMPAIGN_TYPE_SELECTOR':
        case 'START_CLOSING_CAMPAIGN_TYPE_SELECTOR':
            return true;
        case 'CLOSE_CAMPAIGN_TYPE_SELECTOR':
            return false;
        default:
            return state;
    }
};
const isCampaignTypeSelectorClosing = (state = false, action) => {
    switch (action.type) {
        case 'START_CLOSING_CAMPAIGN_TYPE_SELECTOR':
            return true;
        case 'OPEN_CAMPAIGN_TYPE_SELECTOR':
        case 'CLOSE_CAMPAIGN_TYPE_SELECTOR':
            return false;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    isCreatingCampaign,
    isFetching,
    isNewCampaignPopoverOpen,
    isNewCampaignPopoverClosing,
    isCampaignTypeSelectorOpen,
    isCampaignTypeSelectorClosing,
});
exports.getIsCreatingCampaign = (state) => state.isCreatingCampaign;
exports.getIsFetching = (state) => state.isFetching;
exports.getIsNewCampaignPopoverOpen = (state) => state.isNewCampaignPopoverOpen;
exports.getIsNewCampaignPopoverClosing = (state) => state.isNewCampaignPopoverClosing;
exports.getIsCampaignTypeSelectorOpen = (state) => state.isCampaignTypeSelectorOpen;
exports.getIsCampaignTypeSelectorClosing = (state) => state.isCampaignTypeSelectorClosing;
